import ProgressIndicator from './directives/ProgressIndicator';

export default angular.module('edge.quoteandbind.util.app', []).directive('gwProgressIndicator', ProgressIndicator);


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/quoteandbind/util/app.js
// module id = 395
// module chunks = 0